import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Drawer,
  Layout,
  Menu,
  Input,
  Breadcrumb,
  Button,
  Space,
  List,
  Tooltip,
  Typography,
  Tag,
  Divider,
  Dropdown,
  Select,
  Pagination,
  message,
  Progress,
  Popconfirm,
} from "antd";
import {
  FolderOutlined,
  FileOutlined,
  DownloadOutlined,
  AppstoreOutlined,
  UnorderedListOutlined,
  SearchOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  FolderOpenOutlined,
  FilePdfOutlined,
  FileExcelOutlined,
  FileImageOutlined,
  CloseOutlined,
  MoreOutlined,
  EyeOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import axios from "axios";

import config from "../../config";
import GenerarTodosLosPDFs from "./autogenerarPdfAutomatico";
import {useSelector } from 'react-redux';
import { selectAppPermissions } from '../../store/auth/selectors';
const API_BASE = config.baseUrl;

const { Sider, Content } = Layout;
const { Title, Text } = Typography;
const { Option } = Select;

const lista_nombre_archivo = [
  { id: "Novedad", nombre: "Novedad" },
  { id: "Consentimiento", nombre: "Consentimiento" },
  { id: "Diagnostico", nombre: "Diagnostico parte 1" },
  { id: "Capacidades", nombre: "Analisis de capacidades" },
  { id: "Autorizacion", nombre: "Autorización de imagen" },
  { id: "Acta_inicio", nombre: "Acta de inicio" },
  { id: "Visita", nombre: "Visita técnica" },
  // Agrega más si los necesitas
];

function useIsMobile(breakpoint = 600) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);
  return isMobile;
}

const FileManagerPrueba = ({ pathInicial }) => {
  const navigate = useNavigate();
  const [fullTree, setFullTree] = useState([]);
  const [files, setFiles] = useState([]);
  const [filesFiltered, setFilesFiltered] = useState([]);

  const [nombreArchivo, setNombreArchivo] = useState("");
  const [codigoParticipante, setCodigoParticipante] = useState("");

  const [currentPath, setCurrentPath] = useState("");
  const [breadcrumbPaths, setBreadcrumbPaths] = useState([]);
  const [search, setSearch] = useState("");
  const [collapsed, setCollapsed] = useState(false);
  const [viewMode, setViewMode] = useState("list"); // "list" o "grid"
  const [searchAlert, setSearchAlert] = useState(""); // Para el mensaje de alerta
  const [mobileSidebar, setMobileSidebar] = useState(false);
  const [mobileAction, setMobileAction] = useState(null); // "buscar", "vista", "descargar"

  const isMobile = useIsMobile(600);

  //Paginación para grid
  const [currentPageCarpetas, setCurrentPageCarpetas] = useState(1);
  const [currentPageArchivos, setCurrentPageArchivos] = useState(1);

  const pageSize = 10; // Puedes ajustarlo si deseas

  const [carpetas, setCarpetas] = useState([]);
  const [archivos, setArchivos] = useState([]);

  const [totalArchivos, setTotalArchivos] = useState(0);
  const [totalCarpetas, setTotalCarpetas] = useState(0);

  // Calcular los elementos actuales según la página
  // Carpetas
  const indexOfLastCarpeta = currentPageCarpetas * pageSize;
  const indexOfFirstCarpeta = indexOfLastCarpeta - pageSize;
  const currentCarpetas = carpetas.slice(
    indexOfFirstCarpeta,
    indexOfLastCarpeta
  );

  // Archivos
  const indexOfLastArchivo = currentPageArchivos * pageSize;
  const indexOfFirstArchivo = indexOfLastArchivo - pageSize;
  const currentArchivos = archivos.slice(
    indexOfFirstArchivo,
    indexOfLastArchivo
  );

  const usernameFromState = useSelector((state) => state.auth.user);

  const [descargando, setDescargando] = useState(false);
  const [progresoDescarga, setProgresoDescarga] = useState(0);

  const [currentFolderContent, setCurrentFolderContent] = useState([]);

      //Control de Permisos
      const appName = 'file-manager-paati';
      const permissions = useSelector((state) => selectAppPermissions(state, appName));
      const permissionDelete = permissions.priv_delete === 'Y';
  // 📋 useEffect para manejar el contenido de la carpeta actual y filtros
  useEffect(() => {
    // Obtener el contenido de la carpeta actual
    const folderContent = findFilesByPath(filesFiltered, currentPath);

    // Aplicar filtro de búsqueda local (search)
    const filteredFiles = folderContent.filter((f) =>
      f.name.toLowerCase().includes(search.toLowerCase())
    );

    // Separar carpetas y archivos
    const nuevasCarpetas = filteredFiles.filter((f) => f.type === "folder");
    const nuevosArchivos = filteredFiles.filter((f) => f.type === "file");

    // Calcular totales sobre el árbol filtrado completo (no solo la carpeta actual)
    const totalArchivosCalculados = totalFiles(filesFiltered);
    const totalCarpetasCalculadas = totalFolders(filesFiltered);

    // Actualizar estados
    setCarpetas(nuevasCarpetas);
    setArchivos(nuevosArchivos);
    setTotalArchivos(totalArchivosCalculados);
    setTotalCarpetas(totalCarpetasCalculadas);
    setCurrentFolderContent(folderContent);
  }, [filesFiltered, search, currentPath]); // Dependencias clave

  // Ahora puedes usar carpetas y archivos en useEffect
  useEffect(() => {
    if (
      search.trim() !== "" &&
      carpetas.length === 0 &&
      archivos.length === 0
    ) {
      setSearchAlert("No se encontraron carpetas ni archivos con ese nombre.");
    } else {
      setSearchAlert("");
    }
  }, [search, carpetas, archivos]);

  // Esto debe estar dentro de tu componente
  useEffect(() => {
    if (isMobile && mobileAction === "actualizar") {
      fetchFiles(); // Actualizar los archivos
      setNombreArchivo(""); // Limpiar el filtro por nombre
      setCodigoParticipante(""); // Limpiar el filtro por código
      setSearch(""); // Limpiar la búsqueda
      message.success("Repositorio actualizado correctamente.");
    }
  }, [isMobile, mobileAction]);

  const fetchFiles = async () => {
    try {
      const departamentosSeleccionados = usernameFromState.departamento;

      const nombresDepartamentos = departamentosSeleccionados.map(
        (dep) => dep.departamento
      );

      const response = await axios.get(`${API_BASE}/api/file-system`, {
        params: {
          path: pathInicial,
          names: nombresDepartamentos.join(","), // ✅ Aquí ya envías el string correcto
        },
      });

      const data = response.data;

      setFullTree(data);
      setFiles(data);
      setCurrentFolderContent(data); // Inicializa el contenido de la carpeta actual
      setFilesFiltered(data);
      setCurrentPath(pathInicial);

      // Si quieres que el breadcrumb muestre "Inicio" cuando es la raíz
      setBreadcrumbPaths([
        {
          name: pathInicial === "" ? "Inicio" : pathInicial,
          path: pathInicial,
        },
      ]);
    } catch (error) {
      console.error("Error fetching files:", error);
    }
  };

 const removeFileFromTree = (tree, targetPath) => {
  return tree
    .map((item) => {
      // Si es carpeta, revisar hijos
      if (item.type === "folder" && item.children) {
        return {
          ...item,
          children: removeFileFromTree(item.children, targetPath),
        };
      }
      return item;
    })
    .filter((item) => item.path !== targetPath);
};

  useEffect(() => {
    fetchFiles();
  }, []);

  // Estados para el Drawer de descargas
  const [descargas, setDescargas] = useState([]); // [{id, nombre, progreso, estado}]
  const [drawerDescargasVisible, setDrawerDescargasVisible] = useState(false);

  // MODIFICACIÓN: función de descarga con soporte para múltiples descargas y progreso individual
  const handleDownloadZIP = async (path) => {
    const idDescarga = Date.now() + Math.random(); // id único
    let nombreDescarga = "Archivos.zip";
    let tipoDescarga = "filtrado";
    let ruta_completa = "";
    let filesToDownload = [];
    let requestConfig = {};
    let urlRequest = "";
    let bodyRequest = {};

    if (nombreArchivo || codigoParticipante) {
      // Descargar SOLO los archivos de la carpeta seleccionada (por su path)
      // 1. Busca la carpeta en el árbol filtrado actual
      const folderContent = findFilesByPath(filesFiltered, path);

      // 2. Extrae los archivos de esa carpeta
      if (isFlatFileList(folderContent)) {
        filesToDownload = folderContent.map(
          (file) => `${pathInicial}/${file.path}`
        );
      } else {
        filesToDownload = extractFilePaths(folderContent);
      }

      urlRequest = `${API_BASE}/api/file-system/download-filtered`;
      bodyRequest = { path: pathInicial, files: filesToDownload };
      nombreDescarga = `${path.split("/").pop() || "Carpeta"}.zip`;
      tipoDescarga = "filtrado";
    } else {
      // Descarga de carpeta completa (toda la raíz)
      if (!currentPath || currentPath === pathInicial) {
        ruta_completa = pathInicial;
      } else {
        ruta_completa = [pathInicial, currentPath].filter(Boolean).join("/");
      }

      ruta_completa = ruta_completa.replace(/\/{2,}/g, "/");
      urlRequest = `${API_BASE}/api/file-system/download-folder`;
      bodyRequest = { path: ruta_completa };
      nombreDescarga = `${path.split("/").pop() || "Carpeta"}.zip`;
      tipoDescarga = "carpeta";
    }

    // Agregar la descarga al Drawer
    setDescargas((prev) => [
      ...prev,
      {
        id: idDescarga,
        nombre: nombreDescarga,
        progreso: 0,
        estado: "descargando",
        tipo: tipoDescarga,
      },
    ]);
    setDrawerDescargasVisible(true);

    try {
      const response = await axios.post(urlRequest, bodyRequest, {
        responseType: "blob",
        onDownloadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setDescargas((prev) =>
            prev.map((d) =>
              d.id === idDescarga ? { ...d, progreso: percentCompleted } : d
            )
          );
        },
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nombreDescarga);
      document.body.appendChild(link);
      link.click();
      link.remove();

      setDescargas((prev) =>
        prev.map((d) =>
          d.id === idDescarga
            ? { ...d, progreso: 100, estado: "completado" }
            : d
        )
      );
      message.success("Descarga completada con éxito");
    } catch (error) {
      setDescargas((prev) =>
        prev.map((d) => (d.id === idDescarga ? { ...d, estado: "error" } : d))
      );
      message.error("Error al descargar archivos");
    }
  };

  const extractFilePaths = (nodes) => {
    let filePaths = [];

    nodes.forEach((node) => {
      if (node.type === "file") {
        // 🔗 Aquí le antepones pathInicial correctamente
        filePaths.push(`${pathInicial}/${node.path}`);
      } else if (
        node.type === "folder" &&
        node.children &&
        node.children.length > 0
      ) {
        filePaths = filePaths.concat(extractFilePaths(node.children));
      }
    });

    return filePaths;
  };

  const isFlatFileList = (nodes) => {
    // Si todos los elementos son tipo 'file', es lista plana
    return nodes.every((node) => node.type === "file");
  };

  const renderFolderTree = (folders, basePath = "") => {
    return folders.map((folder) => {
      if (folder.type === "folder") {
        const folderPath = basePath
          ? `${basePath}/${folder.name}`
          : folder.name;
        return (
          <Menu.SubMenu
            key={folderPath}
            icon={<FolderOutlined />}
            title={folder.name}
            onTitleClick={() => changeFolder(folderPath)}
          >
            {folder.children && renderFolderTree(folder.children, folderPath)}
          </Menu.SubMenu>
        );
      }
      return null;
    });
  };

  const totalFiles = (tree) => {
    let count = 0;
    tree.forEach((item) => {
      if (item.type === "file") count++;
      if (item.children) count += totalFiles(item.children);
    });
    return count;
  };

  const totalFolders = (tree) => {
    let count = 0;
    tree.forEach((item) => {
      if (item.type === "folder") count++;
      if (item.children) count += totalFolders(item.children);
    });
    return count;
  };

  // Función para elegir el ícono según la extensión del archivo
  const getFileIcon = (fileName) => {
    const ext = fileName.split(".").pop().toLowerCase();
    if (["xls", "xlsx", "csv"].includes(ext)) {
      return <FileExcelOutlined style={{ fontSize: 28, color: "#2e7d32" }} />;
    }
    if (["pdf"].includes(ext)) {
      return <FilePdfOutlined style={{ fontSize: 28, color: "#d32f2f" }} />;
    }
    if (["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(ext)) {
      return <FileImageOutlined style={{ fontSize: 28, color: "#1976d2" }} />;
    }
    // Por defecto
    return <FileOutlined style={{ fontSize: 28, color: "#1677ff" }} />;
  };

  // Calcula los datos de la carpeta actual
  const currentFolder = breadcrumbPaths.length
    ? breadcrumbPaths[breadcrumbPaths.length - 1]
    : { name: "PAATI", path: "" };

  const numSubcarpetas = carpetas.length;
  const numArchivos = archivos.length;

  const vistaMenu = {
    items: [
      {
        key: "list",
        label: (
          <span>
            <UnorderedListOutlined /> Lista
          </span>
        ),
      },
      {
        key: "grid",
        label: (
          <span>
            <AppstoreOutlined /> Cuadrícula
          </span>
        ),
      },
    ],
    onClick: ({ key }) => setViewMode(key),
  };

  const mobileMenu = {
    items: [
      { key: "actualizar", label: "Actualizar" },
      { key: "filtrarFormato", label: "Filtrar formato" },
      { key: "buscar", label: "Buscar" },
      { key: "vista", label: "Vista" },
    ],
    onClick: ({ key }) => setMobileAction(key),
  };

  //Función para buscar carpetas por codigo pre del participante

  // 🔍 Busca carpetas por código manteniendo la jerarquía completa
  const buscarCarpetasConJerarquia = (nodos, codigo) => {
    const codigoBase = (codigo || "").trim();

    const filtrarConJerarquia = (nodos, path = "") => {
      const resultado = [];

      for (const nodo of nodos) {
        if (nodo.type === "folder") {
          const nodoPath = path ? `${path}/${nodo.name}` : nodo.name;

          // Verificar si el nodo actual coincide con el código
          const coincideDirectamente = nodo.name.startsWith(codigoBase);

          // Buscar recursivamente en los hijos
          const hijosFiltrados = filtrarConJerarquia(
            nodo.children || [],
            nodoPath
          );

          // Incluir el nodo si coincide directamente O tiene hijos que coinciden
          if (coincideDirectamente || hijosFiltrados.length > 0) {
            resultado.push({
              ...nodo,
              path: nodoPath,
              // Si coincide directamente, mantener todos sus hijos
              // Si no coincide pero tiene hijos filtrados, solo incluir esos
              children: coincideDirectamente ? nodo.children : hijosFiltrados,
            });
          }
        }
      }

      return resultado;
    };

    return filtrarConJerarquia(nodos);
  };

  // 🔍 Filtrar archivos por palabra clave manteniendo estructura de carpetas
  const filterFilesByKeywordFrontend = (tree, keyword) => {
    if (!keyword || !keyword.trim()) return tree;

    const keywordLower = (keyword || "").toLowerCase().trim();

    return tree
      .map((item) => {
        if (item.type === "folder" && item.children) {
          // Filtrar recursivamente los hijos
          const filteredChildren = filterFilesByKeywordFrontend(
            item.children,
            keyword
          );

          // Si tiene hijos filtrados, incluir la carpeta
          if (filteredChildren.length > 0) {
            return {
              ...item,
              children: filteredChildren,
            };
          }
          return null;
        }

        // Para archivos, verificar si el nombre contiene la palabra clave
        if (
          item.type === "file" &&
          item.name.toLowerCase().includes(keywordLower)
        ) {
          return item;
        }

        return null;
      })
      .filter(Boolean);
  };

  // 🔍 Buscar archivos por ruta específica
  const findFilesByPath = (tree, targetPath) => {
    if (!targetPath || targetPath === "" || targetPath === pathInicial) {
      return tree;
    }

    const pathSegments = targetPath.split("/").filter(Boolean);
    let currentLevel = tree;

    for (const segment of pathSegments) {
      const folder = currentLevel.find(
        (item) => item.type === "folder" && item.name === segment
      );

      if (!folder || !folder.children) {
        return [];
      }

      currentLevel = folder.children;
    }

    return currentLevel;
  };

  // 🔍 Manejar búsqueda por código de participante
  const handleSearch = (value) => {
    const valorSeguro = (value || "").trim();
    if (!valorSeguro) {
      handleChangeLimpiarFiltro();
      return;
    }

    const carpetasConJerarquia = buscarCarpetasConJerarquia(files, valorSeguro);

    if (carpetasConJerarquia.length === 0) {
      message.error("No se encontraron carpetas para el código proporcionado.");
      return;
    }

    // Actualizar estados
    setCodigoParticipante(valorSeguro);

    // Aplicar filtro de código
    let resultadoFiltrado = carpetasConJerarquia;

    // Si también hay filtro por nombre, aplicarlo
    if (nombreArchivo.trim()) {
      resultadoFiltrado = filterFilesByKeywordFrontend(
        resultadoFiltrado,
        nombreArchivo
      );
    }

    setFilesFiltered(resultadoFiltrado);
    setFullTree(resultadoFiltrado);

    // Verificar si la ruta actual sigue existiendo tras el filtro
    const filesEnRutaActual = findFilesByPath(resultadoFiltrado, currentPath);
    if (filesEnRutaActual.length === 0) {
      setCurrentPath(""); // Solo si la ruta ya no existe
    }
  };

  // 🔍 Manejar filtro por nombre de archivo
  const handleChangeFiltroPorNombre = (value) => {
    const valorSeguro = (value || "").trim();
    setNombreArchivo(valorSeguro);

    if (!valorSeguro) {
      // Si se limpia el filtro por nombre, mantener solo el filtro por código (si existe)
      const baseTree = codigoParticipante
        ? buscarCarpetasConJerarquia(files, codigoParticipante)
        : files;

      setFilesFiltered(baseTree);
      setFullTree(baseTree);
      // ❌ NO llamar changeFolder - el useEffect se encargará automáticamente
      return;
    }

    // Determinar el árbol base (con o sin filtro de código)
    const baseTree = codigoParticipante
      ? buscarCarpetasConJerarquia(files, codigoParticipante)
      : files;

    // Aplicar filtro por nombre sobre el árbol base
    const resultadoFiltrado = filterFilesByKeywordFrontend(
      baseTree,
      valorSeguro
    );

    if (resultadoFiltrado.length === 0) {
      // Solo mostrar mensaje, NO cambiar estados
      message.error("No se encontraron archivos o carpetas con ese nombre.");
      return;
    }

    setFilesFiltered(resultadoFiltrado);
    setFullTree(resultadoFiltrado);

    // Verificar si la ruta actual sigue existiendo tras el filtro
    const filesEnRutaActual = findFilesByPath(resultadoFiltrado, currentPath);
    if (filesEnRutaActual.length === 0) {
      setCurrentPath(""); // Solo si la ruta ya no existe
    }
    // Si la ruta existe, no la cambies
  };

  // 🔄 Limpiar todos los filtros
  const handleChangeLimpiarFiltro = () => {
    setNombreArchivo("");
    setCodigoParticipante("");
    setSearch("");

    // Restablecer al árbol original
    setFilesFiltered(files);
    setFullTree(files);
    setBreadcrumbPaths([{ name: "PAATI", path: pathInicial }]);

    // Volver a la ruta inicial
    setCurrentPath("");
    // ❌ NO llamar changeFolder - el useEffect se encarga automáticamente
  };

  // 📁 Cambiar de carpeta
  // 📁 Cambiar de carpeta
  const changeFolder = (newPath) => {
    setCurrentPageCarpetas(1);
    setCurrentPageArchivos(1);

    // Ajustar la ruta (si es pathInicial, usar ruta vacía)
    const pathToUse = newPath === pathInicial ? "" : newPath;

    // Buscar archivos en la nueva ruta usando el árbol filtrado actual
    const newFiles = findFilesByPath(filesFiltered, pathToUse);

    // Actualizar el contenido de la carpeta actual
    setCurrentFolderContent(newFiles);
    setCurrentPath(pathToUse);

    // Construir breadcrumb
    const segments = pathToUse ? pathToUse.split("/").filter(Boolean) : [];
    const breadcrumb = [{ name: "PAATI", path: pathInicial }];

    let accumPath = "";
    segments.forEach((segment) => {
      accumPath += "/" + segment;
      breadcrumb.push({
        name: segment,
        path: accumPath,
      });
    });

    setBreadcrumbPaths(breadcrumb);
    setSearch("");
  };

  // 📋 Función auxiliar para obtener el contenido de la carpeta actual
  const getCurrentFolderContent = () => {
    return findFilesByPath(filesFiltered, currentPath);
  };

  return (
    <>
      {/* HEADER RESPONSIVE */}
      <div
        style={{
          background: "#1976d2",
          padding: "0 8px", // Reduce el padding para pantallas pequeñas
          display: "flex",
          alignItems: "center",
          height: 60,
          justifyContent: "space-between",
          flexWrap: "nowrap", // <-- IMPORTANTE: evita que los hijos se vayan abajo
          gap: 8,
          width: "100vw", // <-- Asegura que ocupe todo el ancho de la ventana
          boxSizing: "border-box",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Button
            type="text"
            icon={
              collapsed || isMobile ? (
                <MenuUnfoldOutlined style={{ color: "#fff", fontSize: 22 }} />
              ) : (
                <MenuFoldOutlined style={{ color: "#fff", fontSize: 22 }} />
              )
            }
            onClick={() => {
              if (isMobile) {
                setMobileSidebar(true);
              } else {
                setCollapsed(!collapsed);
              }
            }}
            style={{ marginRight: 8 }}
          />
          <Title
            level={4}
            style={{
              color: "#fff",
              margin: 0,
              fontSize: 18,
              whiteSpace: "nowrap",
            }}
          >
            Repositorio documental
          </Title>
          {isMobile && (
            <Dropdown menu={mobileMenu} trigger={["click"]}>
              <Button
                type="text"
                icon={<MoreOutlined style={{ color: "#fff", fontSize: 22 }} />}
                style={{ marginLeft: 4 }}
              />
            </Dropdown>
          )}
        </div>
        {!isMobile && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              flex: "0 0 auto",
              marginLeft: "auto",
              overflowX: "auto", // Permite scroll horizontal
              whiteSpace: "nowrap", // Evita que los hijos se vayan hacia abajo
              maxWidth: "100vw", // Asegura que no se desborde
              paddingBottom: 4, // Para que no se corte el scroll
            }}
          >
            <GenerarTodosLosPDFs
              fetchSystemFyle={fetchFiles}
            ></GenerarTodosLosPDFs>

            {(nombreArchivo || codigoParticipante) && (
              <Button
                icon={<DownloadOutlined />}
                type="default"
                onClick={() => {
                  handleChangeLimpiarFiltro(); // Limpiar el filtro por nombre
                  // Puedes agregar aquí otra limpieza si deseas
                }}
                style={{ marginRight: 8 }}
              >
                Limpiar Filtro
              </Button>
            )}

            <Select
              style={{ width: 230 }}
              value={nombreArchivo}
              onChange={handleChangeFiltroPorNombre}
              dropdownStyle={{ maxHeight: 300, overflow: "auto" }}
              placeholder="Selecciona tipo de formato"
            >
              {lista_nombre_archivo.map((tipo) => (
                <Option key={tipo.id} value={tipo.id}>
                  {tipo.nombre}
                </Option>
              ))}
            </Select>

            <Input.Search
              placeholder="Buscar por código"
              onSearch={handleSearch}
              onChange={(e) => setCodigoParticipante(e.target.value)}
              value={codigoParticipante}
              style={{ width: 230, minWidth: 120 }}
              allowClear
              enterButton={
                <Button
                  icon={<SearchOutlined />}
                  type="primary"
                  style={{
                    borderRadius: "6px",
                    background:
                      "linear-gradient(135deg, #32CD32 0%, #28a745 100%)", // Verde degradado
                    border: "none",
                    boxShadow: "0 4px 12px rgba(40, 167, 69, 0.4)",
                  }}
                />
              }
            />

            <Input.Search
              placeholder="Buscar archivo..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ width: 200, minWidth: 120 }}
              allowClear
              enterButton={
                <Button
                  icon={<SearchOutlined />}
                  type="primary"
                  style={{
                    borderRadius: "6px",
                    background:
                      "linear-gradient(135deg, #32CD32 0%, #28a745 100%)", // Verde degradado
                    border: "none",
                    boxShadow: "0 4px 12px rgba(40, 167, 69, 0.4)",
                  }}
                />
              }
            />

            <Dropdown
              menu={vistaMenu}
              placement="bottomRight"
              trigger={["click"]}
            >
              <Button
                icon={
                  viewMode === "list" ? (
                    <UnorderedListOutlined />
                  ) : (
                    <AppstoreOutlined />
                  )
                }
              >
                Vista
              </Button>
            </Dropdown>

            {/* Botón para abrir el Drawer de descargas */}
            <Button
              icon={<DownloadOutlined />}
              onClick={() => setDrawerDescargasVisible(true)}
              style={{ marginLeft: 8 }}
            >
              Descargas
            </Button>
          </div>
        )}
      </div>

      {isMobile && mobileAction === "filtrarFormato" && (
        <div style={{ padding: "8px 16px", background: "#f0f2f5" }}>
          <Select
            style={{ width: 230 }}
            value={nombreArchivo}
            onChange={handleChangeFiltroPorNombre}
            dropdownStyle={{ maxHeight: 300, overflow: "auto" }}
            placeholder="Selecciona tipo de formato"
          >
            {lista_nombre_archivo.map((tipo) => (
              <Option key={tipo.id} value={tipo.id}>
                {tipo.nombre}
              </Option>
            ))}
          </Select>
        </div>
      )}
      {isMobile && mobileAction === "buscar" && (
        <div style={{ padding: "8px 16px", background: "#f0f2f5" }}>
          <Input.Search
            placeholder="Buscar archivo..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            allowClear
            enterButton={
              <Button
                icon={<SearchOutlined />}
                type="primary"
                style={{
                  backgroundColor: "#878e99",
                  borderColor: "#878e99",
                  color: "#fff",
                }}
              />
            }
            style={{ width: "100%" }}
          />
        </div>
      )}

      {isMobile && mobileAction === "vista" && (
        <div
          style={{
            padding: "8px 16px",
            background: "#f0f2f5",
            display: "flex",
            gap: 8,
          }}
        >
          <Button
            type={viewMode === "list" ? "primary" : "default"}
            icon={<UnorderedListOutlined />}
            onClick={() => setViewMode("list")}
            style={{ flex: 1 }}
          >
            Lista
          </Button>
          <Button
            type={viewMode === "grid" ? "primary" : "default"}
            icon={<AppstoreOutlined />}
            onClick={() => setViewMode("grid")}
            style={{ flex: 1 }}
          >
            Cuadrícula
          </Button>
        </div>
      )}

      <Layout style={{ minHeight: "calc(100vh - 64px)", flexDirection: "row" }}>
        {/* SIDEBAR EN ESCRITORIO */}
        {!collapsed && !isMobile && (
          <Sider width={250} className="sidebar" collapsedWidth={0}>
            <div
              style={{
                padding: "0 16px",
                marginBottom: 16,
                backgroundColor: "#fff", // Fondo blanco
              }}
            >
              <Divider />
              <div className="d-flex justify-content-between align-items-center">
                <Text>
                  <FileOutlined style={{ marginRight: 8, color: "#1677ff" }} />
                  Total archivos:
                </Text>
                <Text strong>{totalArchivos}</Text>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <Text>
                  <FolderOpenOutlined
                    style={{ marginRight: 8, color: "#52c41a" }}
                  />
                  Total carpetas:
                </Text>
                <Text strong>{totalCarpetas}</Text>
              </div>
            </div>
            <div
              style={{
                overflowY: "auto",
                maxHeight: "calc(100vh - 200px)",
                minHeight: 0,
                backgroundColor: "#fff", // Fondo blanco para el contenedor del menú
              }}
            >
              <Menu mode="inline" style={{ borderRight: 0 }}>
                {renderFolderTree(fullTree)}
              </Menu>
            </div>
          </Sider>
        )}

        {/* SIDEBAR COMO DRAWER EN MÓVIL */}
        <Drawer
          open={mobileSidebar}
          onClose={() => setMobileSidebar(false)}
          placement="left"
          width="100vw"
          closable={true}
          styles={{
            header: { background: "rgb(22, 119, 255)" },
            body: { padding: 0 },
          }}
        >
          <div style={{ background: "rgb(22, 119, 255)", height: "100vh" }}>
            <Button
              type="text"
              icon={<CloseOutlined style={{ fontSize: 24, color: "#fff" }} />}
              onClick={() => setMobileSidebar(false)}
              style={{
                position: "absolute",
                top: 12,
                right: 12,
                zIndex: 10,
                background: "transparent",
                border: "none",
              }}
            />
            <div style={{ paddingTop: 48 }}>
              <div
                style={{
                  padding: "0 16px",
                  marginBottom: 16,
                  backgroundColor: "#fdfdfd",
                }}
              >
                <Divider />
                <div className="d-flex justify-content-between align-items-center">
                  <Text>
                    <FileOutlined
                      style={{ marginRight: 8, color: "#1677ff" }}
                    />
                    Total archivos:
                  </Text>
                  <Text strong>{totalFiles(fullTree)}</Text>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <Text>
                    <FolderOpenOutlined
                      style={{ marginRight: 8, color: "#52c41a" }}
                    />
                    Total carpetas:
                  </Text>
                  <Text strong>{totalFolders(fullTree)}</Text>
                </div>
              </div>
              <div
                style={{
                  overflowY: "auto",
                  maxHeight: "calc(100vh - 200px)",
                  minHeight: 0,
                }}
              >
                <Menu mode="inline" style={{ borderRight: 0 }}>
                  {renderFolderTree(fullTree)}
                </Menu>
              </div>
            </div>
          </div>
        </Drawer>

        {/* CONTENIDO RESPONSIVE */}
        <Content
          style={{
            padding: "16px 4vw",
            flex: 1,
            backgroundColor: "#FFFFFF",
            minWidth: 0,
            maxWidth: "100vw",
          }}
        >
          {/* Header de carpeta actual */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 16,
              marginBottom: 8,
              marginTop: 8,
              flexWrap: "wrap",
            }}
          >
            <FolderOutlined style={{ fontSize: 32, color: "#1976d2" }} />
            <div>
              <div style={{ fontWeight: 600, fontSize: 22 }}>
                {currentFolder.name}
              </div>
              <div style={{ color: "#888", fontSize: 15 }}>
                {numArchivos} elementos • {numSubcarpetas} subcarpetas
              </div>
              <div style={{ marginTop: 4, display: "flex", flexWrap: "wrap" }}>
                <span style={{ fontWeight: 600 }}>Ubicación: </span>
                {breadcrumbPaths.map((bc, idx) => (
                  <span key={bc.path} style={{ margin: "0 4px" }}>
                    <strong
                      style={{
                        color: "#1677ff",
                        fontWeight: 600,
                        cursor: "pointer",
                      }}
                      onClick={() => changeFolder(bc.path)}
                    >
                      {bc.name}
                    </strong>
                    {idx < breadcrumbPaths.length - 1 && (
                      <span style={{ color: "#888", margin: "0 4px" }}>
                        {" "}
                        &gt;{" "}
                      </span>
                    )}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {searchAlert && (
            <div
              style={{
                background: "#fffbe6",
                border: "1px solid #ffe58f",
                color: "#ad6800",
                padding: 16,
                borderRadius: 8,
                marginBottom: 16,
                fontWeight: 500,
              }}
            >
              {searchAlert}
            </div>
          )}

          <Space style={{ float: "right", marginBottom: 16 }}>
            <Button
              type={viewMode === "list" ? "primary" : "default"}
              icon={<UnorderedListOutlined />}
              onClick={() => setViewMode("list")}
            />
            <Button
              type={viewMode === "grid" ? "primary" : "default"}
              icon={<AppstoreOutlined />}
              onClick={() => setViewMode("grid")}
            />
          </Space>

          {carpetas.length > 0 && (
            <>
              <Divider orientation="left">Carpetas</Divider>
              {viewMode === "list" ? (
                <List
                  pagination={{ pageSize: 5 }} // Puedes cambiar la cantidad de carpetas por página
                  dataSource={carpetas}
                  grid={{
                    gutter: 16,
                    xs: 1,
                    sm: 1,
                    md: 1,
                    lg: 1,
                    xl: 1,
                    xxl: 1,
                  }}
                  renderItem={(folder) => (
                    <List.Item
                      style={{
                        background: "#fff",
                        borderRadius: 12,
                        marginBottom: 16,
                        boxShadow: "0 2px 8px #0000000a",
                        border: "none",
                        padding: 20,
                        transition: "box-shadow 0.2s",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                      onClick={() => changeFolder(folder.path)}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 16,
                        }}
                      >
                        <FolderOutlined
                          style={{ fontSize: 28, color: "#1677ff" }}
                        />
                        <div>
                          <div style={{ fontWeight: 600, fontSize: 16 }}>
                            {folder.name}
                          </div>
                          <div style={{ color: "#888" }}>
                            {folder.children
                              ? `${folder.children.length} elementos`
                              : "0 elementos"}
                          </div>
                        </div>
                      </div>
                      <Tooltip title="Descargar carpeta como ZIP">
                        <Button
                          shape="circle"
                          icon={
                            <DownloadOutlined style={{ color: "#1677ff" }} />
                          }
                          style={{ background: "#f0f7ff", border: "none" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDownloadZIP(folder.path);
                          }}
                        />
                      </Tooltip>
                    </List.Item>
                  )}
                />
              ) : (
                <>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 24,
                      marginBottom: 24,
                      justifyContent: "flex-start",
                    }}
                  >
                    {currentCarpetas.map((folder) => (
                      <div
                        key={folder.path}
                        style={{
                          width: "min(220px, 90vw)",
                          background: "#fff",
                          borderRadius: 12,
                          boxShadow: "0 2px 8px #0000000a",
                          border: "none",
                          padding: 20,
                          cursor: "pointer",
                          display: "flex",
                          flexDirection: "column",
                          minWidth: 140,
                          margin: 0,
                        }}
                        onClick={() => changeFolder(folder.path)}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                            justifyContent: "space-between",
                            marginBottom: 8,
                          }}
                        >
                          <FolderOutlined
                            style={{ fontSize: 40, color: "#1677ff" }}
                          />
                          <Tooltip title="Descargar carpeta como ZIP">
                            <Button
                              shape="circle"
                              icon={
                                <DownloadOutlined
                                  style={{ color: "#1677ff" }}
                                />
                              }
                              style={{ background: "#f0f7ff", border: "none" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDownloadZIP();
                              }}
                            />
                          </Tooltip>
                        </div>

                        <div
                          style={{
                            fontWeight: 600,
                            fontSize: 16,
                            textAlign: "center",
                            width: "100%",
                          }}
                        >
                          {folder.name}
                        </div>

                        <div
                          style={{
                            color: "#888",
                            fontSize: 14,
                            marginTop: 4,
                            textAlign: "center",
                            width: "100%",
                          }}
                        >
                          {folder.children
                            ? `${folder.children.length} elementos`
                            : "0 elementos"}
                        </div>
                      </div>
                    ))}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginBottom: 40,
                    }}
                  >
                    <Pagination
                      current={currentPageCarpetas}
                      pageSize={pageSize}
                      total={carpetas.length}
                      onChange={(page) => setCurrentPageCarpetas(page)}
                    />
                  </div>
                </>
              )}
            </>
          )}

          {archivos.length > 0 && (
            <>
              <Divider orientation="left">Archivos</Divider>
              {viewMode === "list" ? (
                <List
                  pagination={{ pageSize: 5 }} // Puedes cambiar la cantidad de carpetas por página
                  dataSource={archivos}
                  grid={{
                    gutter: 16,
                    xs: 1,
                    sm: 1,
                    md: 1,
                    lg: 1,
                    xl: 1,
                    xxl: 1,
                  }}
                  renderItem={(file) => (
                    <List.Item
                      style={{
                        background: "#fff",
                        borderRadius: 12,
                        marginBottom: 16,
                        boxShadow: "0 2px 8px #0000000a",
                        border: "none",
                        padding: 20,
                        transition: "box-shadow 0.2s",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 16,
                        }}
                      >
                        {getFileIcon(file.name)}
                        <div>
                          <a
                            href={`${API_BASE}/api/downloadFile?path=${pathInicial}/${encodeURIComponent(
                              file.path
                            )}&t=${new Date().getTime()}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              fontWeight: 600,
                              fontSize: 16,
                              color: "#1677ff",
                            }}
                          >
                            {file.name}
                          </a>
                          <div style={{ color: "#888" }}>
                            {(file.size / 1024).toFixed(2)} KB •{" "}
                            {new Date(file.modified).toLocaleDateString()}{" "}
                            {file.author ? `• ${file.author}` : ""}
                          </div>
                        </div>
                      </div>
                      <Space size="middle">
                        {/* Botón de Visualizar */}
                        <Tooltip title="Visualizar archivo">
                          <Button
                            shape="circle"
                            icon={<EyeOutlined style={{ color: "#52c41a" }} />} // Verde representativo
                            style={{ background: "#f6ffed", border: "none" }} // Fondo verde suave
                            onClick={() =>
                              window.open(
                                `${API_BASE}/documentosFAO/${pathInicial}/${encodeURIComponent(
                                  file.path
                                )}?t=${Date.now()}`,
                                "_blank"
                              )
                            }
                          />
                        </Tooltip>

                        {/* Botón de Descargar */}
                        <Tooltip title="Descargar archivo">
                          <Button
                            shape="circle"
                            icon={
                              <DownloadOutlined style={{ color: "#1677ff" }} />
                            } // Azul representativo
                            style={{ background: "#f0f7ff", border: "none" }} // Fondo azul suave
                            onClick={() =>
                              window.open(
                                `${API_BASE}/api/downloadFile?path=${pathInicial}/${encodeURIComponent(
                                  file.path
                                )}&t=${new Date().getTime()}`,
                                "_blank"
                              )
                            }
                          />
                        </Tooltip>

                    {permissionDelete && (
                     <>
                     {/* Botón de Eliminar archivo */}

                      <Tooltip title="Eliminar archivo">
                          <Popconfirm
                            title="¿Eliminar archivo?"
                            description="Esta acción no se puede deshacer"
                            okText="Sí, eliminar"
                            cancelText="Cancelar"
                            okType="danger"
                            onConfirm={async () => {
                              try {
                                const response = await fetch(
                                  `${API_BASE}/api/file-system/delete-file?path=${pathInicial}/${encodeURIComponent(file.path)}`,
                                  {
                                    method: "DELETE",
                                  }
                                );

                                const data = await response.json();

                                if (!response.ok) {
                                  throw new Error(data.message || "Error al eliminar");
                                }

                                message.success("Archivo eliminado correctamente");

                                            // 🔥 1. quitar de archivos visibles
                                            setArchivos((prev) =>
                                              prev.filter((item) => item.path !== file.path)
                                            );

                                            // 🔥 2. quitar del árbol completo (CLAVE)
                                            setFilesFiltered((prev) =>
                                              removeFileFromTree(prev, file.path)
                                            );

                                            // 🔥 3. también del contenido actual
                                            setCurrentFolderContent((prev) =>
                                              prev.filter((item) => item.path !== file.path)
                                            );


                              } catch (error) {
                                message.error(error.message || "Error al eliminar archivo");
                              }
                            }}
                          >
                            <Button
                              shape="circle"
                              icon={<DeleteOutlined style={{ color: "#ff1616" }} />}
                              style={{ background: "#fff1f0", border: "none" }}
                            />
                          </Popconfirm>
                      </Tooltip>
  </>

                    )}
                      

                      </Space>
                    </List.Item>
                  )}
                />
              ) : (
                <>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 24,
                      marginBottom: 24,
                      justifyContent: "flex-start",
                    }}
                  >
                    {currentArchivos.map((file) => (
                      <div
                        key={file.path}
                        style={{
                          width: "min(320px, 95vw)",
                          background: "#fff",
                          borderRadius: 12,
                          boxShadow: "0 2px 8px #0000000a",
                          border: "none",
                          padding: 20,
                          display: "flex",
                          flexDirection: "column",
                          minWidth: 180,
                          margin: 0,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                            justifyContent: "space-between",
                            marginBottom: 8,
                          }}
                        >
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {getFileIcon(file.name)}
                            <a
                              href={`${API_BASE}/api/downloadFile?path=${pathInicial}/${encodeURIComponent(
                                file.path
                              )}&t=${new Date().getTime()}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                fontWeight: 600,
                                fontSize: 16,
                                color: "#1677ff",
                                marginLeft: 8,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: "60vw",
                              }}
                            >
                              {file.name}
                            </a>
                          </div>
                          <Tooltip title="Descargar archivo">
                            <Button
                              shape="circle"
                              icon={
                                <DownloadOutlined
                                  style={{ color: "#1677ff" }}
                                />
                              }
                              style={{ background: "#f0f7ff", border: "none" }}
                              onClick={() =>
                                window.open(
                                  `${API_BASE}/api/downloadFile?path=${pathInicial}/${encodeURIComponent(
                                    file.path
                                  )}&t=${new Date().getTime()}`,
                                  "_blank"
                                )
                              }
                            />
                          </Tooltip>
                        </div>
                        <div style={{ color: "#888", fontSize: 14 }}>
                          {(file.size / 1024).toFixed(2)} KB •{" "}
                          {new Date(file.modified).toLocaleDateString()}{" "}
                          {file.author ? `• ${file.author}` : ""}
                        </div>
                      </div>
                    ))}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginBottom: 40,
                    }}
                  >
                    <Pagination
                      current={currentPageArchivos}
                      pageSize={pageSize}
                      total={archivos.length}
                      onChange={(page) => setCurrentPageArchivos(page)}
                      style={{ marginBottom: 40, textAlign: "center" }}
                    />
                  </div>
                </>
              )}
            </>
          )}
        </Content>
      </Layout>

      {/* DRAWER DE DESCARGAS */}
      <Drawer
        title="Descargas"
        placement="right"
        onClose={() => setDrawerDescargasVisible(false)}
        open={drawerDescargasVisible}
        width={350}
      >
        <List
          dataSource={descargas}
          renderItem={(item) => (
            <List.Item>
              <div style={{ width: "100%" }}>
                <div style={{ fontWeight: 600 }}>{item.nombre}</div>
                <Progress
                  percent={item.progreso}
                  status={
                    item.estado === "error"
                      ? "exception"
                      : item.estado === "completado"
                      ? "success"
                      : "active"
                  }
                  showInfo={item.progreso > 0 && item.progreso < 100}
                  // Si progreso es 0, muestra barra indeterminada
                  {...(item.progreso === 0 && item.estado === "descargando"
                    ? {
                        type: "line",
                        percent: 99,
                        strokeColor: "#1677ff",
                        showInfo: false,
                      }
                    : {})}
                />
                <div style={{ color: "#888", fontSize: 12 }}>
                  {item.estado === "descargando" && "Descargando..."}
                  {item.estado === "completado" && "Completado"}
                  {item.estado === "error" && "Error"}
                </div>
              </div>
            </List.Item>
          )}
        />
      </Drawer>
    </>
  );
};

export default FileManagerPrueba;
